import { render, staticRenderFns } from "./BoilerComponent.vue?vue&type=template&id=2877895f&scoped=true"
import script from "./BoilerComponent.vue?vue&type=script&lang=js"
export * from "./BoilerComponent.vue?vue&type=script&lang=js"
import style0 from "./BoilerComponent.vue?vue&type=style&index=0&id=2877895f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2877895f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VIcon,VList,VMenu,VSkeletonLoader})
